import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const fmt = (s) => (s ? new Date(s).toLocaleString("id-ID") : "—");

export default function AssistantTokenPanel() {
  const [st, setSt] = useState(null);
  const [tok, setTok] = useState("");
  const [askRevoke, setAskRevoke] = useState(false);
  const load = () => api.get("/admin/assistant-token").then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!st) return null;
  const act = async (fn) => { try { await fn(); load(); } catch (e) { toast.error(apiError(e)); } };
  const create = () => act(async () => { const r = await api.post("/admin/assistant-token"); setTok(r.data.token); });
  const revoke = () => act(async () => { await api.delete("/admin/assistant-token"); setTok(""); setAskRevoke(false); toast.success("Token dicabut"); });
  const toggle = (v) => act(() => api.put("/admin/assistant-token/enabled", { enabled: v }));
  return (
    <div data-testid="assistant-token-panel" className="rounded-2xl border border-indigo-100 bg-white p-5 shadow-sm">
      <h3 className="font-heading text-base font-bold text-slate-800">Akses Asisten (token API)</h3>
      <p className="mt-1 text-xs text-slate-500">Untuk asisten AI lewat header <code>X-Assistant-Token</code> di /api/assistant/… Izin terbatas: baca jadwal &amp; reservasi, kelola sesi/blokir/jadwal layanan, konfirmasi &amp; jadwal ulang reservasi tanpa bayar. Tidak bisa menghapus reservasi, mengubah harga/pembayaran, akun, atau pengaturan WA. Semua aksi tercatat di Log Audit "Asisten".</p>
      <label className="mt-3 flex items-center gap-2 text-sm font-semibold text-slate-700">
        <input data-testid="assistant-enabled-toggle" type="checkbox" checked={st.enabled} onChange={(e) => toggle(e.target.checked)} disabled={!st.has_token} /> Akses Asisten aktif
      </label>
      <p data-testid="assistant-token-info" className="mt-2 text-xs text-slate-500">Token: {st.has_token ? `${st.prefix}… (dibuat ${fmt(st.created_at)})` : "belum ada"} · Terakhir dipakai: {fmt(st.last_used_at)}</p>
      {tok && (
        <div data-testid="assistant-token-once" className="mt-3 rounded-xl border border-amber-300 bg-amber-50 p-3 text-xs text-amber-800">
          <b>Salin sekarang — token hanya ditampilkan sekali:</b>
          <code className="mt-1 block break-all rounded bg-white p-2 font-mono text-slate-800">{tok}</code>
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <button data-testid="assistant-token-create" onClick={create} className="rounded-xl bg-indigo-600 px-4 py-2 text-sm font-bold text-white">{st.has_token ? "Buat Ulang Token" : "Buat Token Asisten"}</button>
        {st.has_token && !askRevoke && <button data-testid="assistant-token-revoke" onClick={() => setAskRevoke(true)} className="rounded-xl bg-rose-50 px-4 py-2 text-sm font-bold text-rose-600">Cabut Token</button>}
        {askRevoke && (
          <span className="flex items-center gap-2 text-xs text-rose-700">Cabut token? Asisten langsung tidak bisa akses.
            <button data-testid="assistant-token-revoke-yes" onClick={revoke} className="rounded bg-rose-600 px-2 py-1 font-bold text-white">Ya, cabut</button>
            <button data-testid="assistant-token-revoke-no" onClick={() => setAskRevoke(false)} className="rounded bg-slate-100 px-2 py-1">Batal</button>
          </span>
        )}
      </div>
    </div>
  );
}
